import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Logger } from 'projects/common/src/app/classes';
import { IRequestError } from 'projects/common/src/app/interfaces/communication/request';
import { BehaviorSubject } from 'rxjs';
import { IWidgetComponentData } from 'src/app/modules/widget/interfaces/widget';

@Component({
  selector: 'app-widget-basic',
  templateUrl: './widget-basic.component.html',
  styleUrls: ['./widget-basic.component.scss'],
})
export class WidgetBasicComponent extends Logger implements OnDestroy {
  @Input()
  public data: IWidgetComponentData;

  @Output()
  public updatedAt: EventEmitter<Date>;

  @Output()
  public errorOccurred = new EventEmitter<IRequestError>();

  @Output()
  public noData = new EventEmitter<boolean>(false);

  @Output()
  public chartWithoutData$ = new BehaviorSubject<boolean>(false);

  public requestError: IRequestError;
  protected componentDestroyed: boolean;

  constructor() {
    super();
    this.componentDestroyed = false;
    this.updatedAt = new EventEmitter();
  }

  /**
   * On destroy component
   */
  public ngOnDestroy(): void {
    this.componentDestroyed = true;
    this.updatedAt.complete();
  }
}
